import { html, ref } from '@microsoft/fast-element';
import { limit, Orientation } from '@microsoft/fast-web-utilities';
/**
 * The template for the {@link @microsoft/fast-foundation#(Slider:class)} component.
 * @public
 */
export const foundationSliderTemplate = (context, definition) => html `
  <template
    role="slider"
    class="${(x) => (x.readOnly ? 'readonly' : '')}
      ${(x) => x.orientation || Orientation.horizontal}"
    tabindex="${(x) => (x.disabled ? null : 0)}"
    aria-valuetext="${(x) => x.valueTextFormatter(x.value)}"
    aria-valuenow="${(x) => x.value}"
    aria-valuemin="${(x) => x.min}"
    aria-valuemax="${(x) => x.max}"
    aria-disabled="${(x) => (x.disabled ? true : void 0)}"
    aria-readonly="${(x) => (x.readOnly ? true : void 0)}"
    aria-orientation="${(x) => x.orientation}"
    class="${(x) => x.orientation}"
  >
    <div part="positioning-region" class="positioning-region">
      <div ${ref('track')} part="track-container" class="track">
        <div
          class="track-progress"
          style="${(x) => {
    const base = 1 - limit(0, 1, (parseInt(x.value) - x.min) / (x.max - x.min));
    const percentage = Math.round((1 - base) * 100);
    if (x.orientation === 'horizontal') {
        return x.isDragging
            ? `height: calc(var(--track-width) * 1px); width: ${percentage}%;`
            : `height: calc(var(--track-width) * 1px); width: ${percentage}%; transition: all 0.2s ease;`;
    }
    else {
        return x.isDragging
            ? `width: calc(var(--track-width) * 1px); height: ${percentage}%;`
            : `width: calc(var(--track-width) * 1px); height: ${percentage}%; transition: all 0.2s ease;`;
    }
}}"
        ></div>
      </div>
      <slot></slot>
      <div
        ${ref('thumb')}
        part="thumb-container"
        class="thumb-container"
        style="${(x) => x.position}"
      >
        <slot name="thumb">${definition.thumb || ''}</slot>
      </div>
    </div>
  </template>
`;
